<template>
    <header class="main-header">
        <scheme-logo class="main-header__logo" />
        <main-nav class="main-header__nav" />
    </header>
</template>

<script>

import MainNav from '@/components/header/main-nav'
import SchemeLogo from '@/components/header/scheme-logo'

export default {

    mounted() {
        this.$eventbus.$emit(this.$appevents.pageTyped, 'main')
    },

    components: {
        MainNav,
        SchemeLogo,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.main-header {
    @include header;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @include element('logo') {
        flex: 1 1 auto;
    }

    @include element('nav') {
        flex: 1 0 auto;
    }
}

</style>
